import { render, staticRenderFns } from "./MatriculasAeeCard.vue?vue&type=template&id=ef919640&scoped=true"
import script from "./MatriculasAeeCard.vue?vue&type=script&lang=js"
export * from "./MatriculasAeeCard.vue?vue&type=script&lang=js"
import style0 from "./MatriculasAeeCard.vue?vue&type=style&index=0&id=ef919640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef919640",
  null
  
)

export default component.exports